import Clipboard from "@assets/clipboard.svg";
import Bell from "@assets/icon_Bell.svg";
import Alert from "@assets/Alert.svg";
import ReminderWithNoNotification from "@assets/ReminderWithNoNotification.svg";
import Aperture from "@assets/Aperture.svg";
export interface SortData {
  [key: string]: {
   order?: "ascend" | "descend";
   columnKey?: string;
 };
}

export const routeMap = {
  home: "/",
  login: "/auth/login",
  ssoRedirect: "/auth/sso-redirect",
  "forgot-password": "/auth/forgot-password",
  "reset-password": "/auth/reset-password/:token/:domain_id",
  members: "/members",
  dashboard: "/dashboard",
  memberProfile: "/member-detail",
  setting: "/setting",
  cmadmin: "/cm-admin",
  upload: "/upload",
  wellbe: "/dataAdministration",
  "care-lite": "/care-lite",
};

export const rightDrawerActions = [
  {
    icon: Alert,
    alt: "Alerts",
    id: "Alerts",
    canExpand : false
  },
  {
    icon: Clipboard,
    alt: "Notes",
    id: "Notes",
    drawerClassName: "drawer-notes",
    canExpand : false
  },
  {
    icon: ReminderWithNoNotification,
    alt: "Reminders",
    id: "Reminders",
    drawerClassName: "reminder-drawer",
    canExpand : true
  },
  {
    icon: Aperture,
    alt: "Recorded Entries",
    id: "Recorded Entries",
    drawerClassName: "outreaches-drawer",
    canExpand : false
  },
  {
    icon: Bell,
    alt: "Notification",
    id: "Notification",
    drawerClassName: "drawer-notifications",
    canExpand : false
  },
];

export const notesDrawerFilterOptions = [
  {
    label: "Today",
    value: "1",
  },
  {
    label: "Yesterday",
    value: "2",
  },
  {
    label: "Last 2 days",
    value: "3",
  },
  {
    label: "Last 7 days",
    value: "8",
  },
  {
    label: "Clear Filters",
    value: "0",
  },
];

export const notificationsDrawerFilterOptions = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Yesterday",
    value: "yesterday",
  },
  {
    label: "Last 2 days",
    value: "last_2_days",
  },
  {
    label: "Last 7 days",
    value: "last_7_days",
  },
];

export interface ReminderStatus {
  label: string;
  value: string;
  colorCode: string;
}

export const REMINDER_SUCCESSFUL_VALUE = "success";
export const REMINDER_UNSUCCESSFUL_VALUE = "unSuccessful";
export const REMINDER_NO_ACTION = "noAction";
export const REMINDER_FUTURE_DATED_NO_ACTION = "future-noAction-reminder";

export const REMINDER_STATUS_LIST : ReminderStatus[] = [
  { label: "Successful", value: REMINDER_SUCCESSFUL_VALUE, colorCode: "#1BBE75" },
  { label: "Unsuccessful", value: REMINDER_UNSUCCESSFUL_VALUE, colorCode: "#E75547" },
  { label: "No Action", value: REMINDER_NO_ACTION, colorCode: "#F2960D" },
];

export const REMINDER_STATUS_COLOR_CODE:any = {
  "success": "#1BBE75",
  "unSuccessful": "#E75547",
  "noAction": "#F2960D",
  "future-noAction-reminder": "#0072E3"
}

export const REMINDER_STATUS_COLOR_CODE_FOR_BACKGROUND:any = {
  "success": "#E8F8F1",
  "unSuccessful": "#FDEEED",
  "noAction": "#FEF5E7",
  "future-noAction-reminder": "#E6F1FC"
}

export const ignorableUrls = [
  "health-check",
  "login",
  "getmfaqrcode",
  "forgot-password",
  "refreshToken",
  "reset-password",
  process.env.REACT_APP_MAP_BASE_URL,
  "domains",
  process.env.REACT_APP_WEATHER_BASE_URL,
];

export const Headers = { ContentType: "Content-Type", Authorization: "Authorization", HTTPReferrer: "HTTP-Referrer" };

// Constants for Notes and Reminder origin

export const MEMBER_LIST_LOCAL = "memlist_local";
export const MEMBER_LIST_GLOBAL = "memlist_globl";
export const MEMBER_DETAILS_LOCAL = "memdetl_local";
export const MEMBER_DETAILS_CLOSE_CASE = "memdetl_caseclse";
export const MEMBER_DETAILS_CARE_MANAGEMENT_TASKS = "carecrdtn_task";
export const MEMBER_DETAILS_CARE_MANAGEMENT_SUB_TASK = "carecrdtn_subTask";
export const MEMBER_DETAILS_CARE_MANAGEMENT_GOALS = "carecrdtn_goal";
export const MEMBER_DETAILS_FOLLOWUP_REMINDER = "followup_reminder";
export const MEMBER_DETAILS_CASE_STATUS_ACTIVE = "member-detail-active-case-status";
export const MEMBER_DETAILS_CASE_STATUS_FOLLOW_UP = "member-detail-follow-up-case-status";
export const MEMBER_DETAILS_CASE_STATUS_GRADUATED = "member-detail-graduated-case-status";
export const MEMBER_DETAILS_CASE_STATUS_DECLINED = "member-detail-declined-case-status";
export const MEMBER_DETAILS_CASE_STATUS_EXTERNAL = "member-detail-external-case-status";
export const MEMBER_DETAILS_CARE_TEAM_ASSIGNMENT = "member-detail-care-team-assignment";


export const CONTENT_ORIGIN_TYPE: any = {
  memlist_local: "MEMBER LIST",
  memlist_globl: "MEMBER LIST GLOBAL",
  memdetl_local: "MEMBER DETAIL",
  memdetl_caseclse: "MEMBER CASE CLOSE",
  carecrdtn_task: "CARE MANAGEMENT",
  carecrdtn_goal: "CARE MANAGEMENT",
  followup_reminder: "FOLLOW UP",
};

// Constants for screen title
export const MEMBERS_SCREEN_TITLE = "MEMBERS_SCREEN";
export const MEMBERS_DETAILS_SCREEN_TITLE = "MEMBERS_DETAILS_SCREEN";
export const CARE_MANAGEMENT_SCREEN_TITLE = "care-co-ordination";
export const CARE_MANAGEMENT_GOAL_SCREEN_TITLE = "care-co-ordination-goal";

// export const config = [
//    {
//     clientName: "Tredence Dev",
//     formate : "YYYY MM DD",
//     formateHyphen : "YYYY-MM-DD",
//     actualFormate : "YYYY-MM-DD HH:mm:ss",
//     formateWithPipe : "YYYY-MM-DD | HH:mm"
//   },
//   {
//     clientName: 'Marquee',
//     formate : "DD MMM YYYY",
//     formateHyphen : "DD-MM-YYYY",
//     actualFormate : "DD-MM-YYYY HH:mm:ss",
//     formateWithPipe : "DD MMM YYYY | HH:mm"
//   },
//   {
//     clientName: 'Mycare',
//     formate : "YYYY MM DD",
//     formateHyphen : "YYYY-MM-DD",
//     actualFormate : "YYYY-MM-DD HH:mm:ss",
//     formateWithPipe : "YYYY-MM-DD | HH:mm"
//   }
// ]

export const phoneFormatConfig: Map<any, any> = new Map();

phoneFormatConfig.set("Tredence Dev", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Tredence", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Marquee", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Mycare", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("SightMD", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Millennium", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Centric", {
  usFormat: "(999) 999-9999",
});

phoneFormatConfig.set("Wellbe", {
  usFormat: "(999) 999-9999",
});

export const dateFormatConfig: Map<any, any> = new Map();

dateFormatConfig.set("Tredence Dev", {
  longDateFormat: "YYYY MMM DD",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "YYYY-MMM-DD",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "YYYY MMM DD | HH:mm",
  formatLocalDateTime: "YYYY MMM DD, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD",
  dateTimeReportNoteCreatedFormat: "YYYY-MM-DD hh:mm A",
});

dateFormatConfig.set("Tredence", {
  longDateFormat: "YYYY MMM DD",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "YYYY-MMM-DD",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "YYYY MMM DD | HH:mm",
  formatLocalDateTime: "YYYY MMM DD, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD"
});

dateFormatConfig.set("Marquee", {
  longDateFormat: "DD MMM YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "DD-MMM-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "DD MMM YYYY | HH:mm",
  formatLocalDateTime: "DD MMM YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD"
});

dateFormatConfig.set("Mycare", {
  longDateFormat: "MMM DD YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "MMM-DD-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "MMM DD YYYY | HH:mm",
  formatLocalDateTime: "MMM DD YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD"
});

dateFormatConfig.set("Centric", {
  longDateFormat: "MMM DD YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "MMM-DD-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "MMM DD YYYY | HH:mm",
  formatLocalDateTime: "MMM DD YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD",
  dateTimeReportNoteCreatedFormat: "YYYY-MM-DD hh:mm A",
});

dateFormatConfig.set("Millennium", {
  longDateFormat: "MMM DD YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "MMM-DD-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "MMM DD YYYY | HH:mm",
  formatLocalDateTime: "MMM DD YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD"
});

dateFormatConfig.set("SightMD", {
  longDateFormat: "MMM DD YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "MMM-DD-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "MMM DD YYYY | HH:mm",
  formatLocalDateTime: "MMM DD YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
  reportUpdatedDateTimeFormat: "MM-DD-YYYY h:mm A",
  withoutHyphenDate: "YYYYMMDD",
  slashFormat: "YYYY/MM/DD"
});

dateFormatConfig.set("Wellbe", {
  longDateFormat: "MMM DD YYYY",
  shortDateFormat: "MMM Do | h:mm a",
  longDateFormatHyphen: "MMM-DD-YYYY",
  shortDateFormatHyphen: "Do-MMM | h:mm a",
  actualFormat: "DD-MM-YYYY HH:mm:ss",
  formatWithPipe: "MMM DD YYYY | HH:mm",
  formatLocalDateTime: "MMM DD YYYY, hh:mm A",
  formatDateForReminder: "MMM Do YYYY",
  formatTimeForReminder: "h:mm A",
  createDateFormat: "YYYY-MM-DD",
  LastGapClosedFormat: "DD MMMM YYYY",
  LastActionFormat: "MM/DD/YYYY",
  defaultDateFormat: "MM-DD-YYYY",
  defaultDateFormatWithTime: "MM-DD-YYYY, HH:mm:ss",
  defaultDateFormatWithTimeWithPipe: "MMM Do YYYY | h:mm a",
  reminderDateActualFormat: "YYYY-MM-DD HH:mm:ss",
  shortDateFormatWithYear: "MMM Do YYYY | h:mm a",
  refreshDateFormat: "MM-DD-YYYY HH:mm z",
  dataRefreshDateFormat: "YYYY-MM",
  dataRefreshDateFormatForEncountersData: "MMM YYYY",
  dateTimeColumnFilterDisplayFormat: "MM-DD-YYYY HH:mm",
  dateTimeColumnFilterFormat: "YYYY-MM-DD HH:mm",
  unitedStateDateTimeFormatWithoutSeconds: "MM-DD-YYYY, HH:mm",
  dateTimeColumnFilterDisplayFormatWithTime: "MM-DD-YYYY hh:mm A",
});

export const EQUALS = "equals";
export const NOT_EQUALS = "notequals";
export const CONTAINS = "contains";
export const CREATE = "create";
export const CARE_PRGM = "careprgm";
export const CREATE_CARE_PRGM = "create careprgm";
export const IS_MANDATORY = "is_mandatory";

//Role Based access for Hospital List and Case Manager list of Roles
export const HOSPITAL_LIST_AND_CM_USER_ACCESS_LIST = ["SysAdmin", "CareManagerAdmin"];

export const enum HOSPITAL_LIST_AND_CM_USER_OPENED_FROM {
  None,
  Members,
  memberDetailADT,
}

//Read Only Notes in Drawer
export const READ_ONLY_DRAWER_NOTES = [
  {
    noteType: MEMBER_DETAILS_CARE_MANAGEMENT_TASKS,
    noteLabel: "CARE MANAGEMENT",
  },
  {
    noteType: MEMBER_DETAILS_CARE_MANAGEMENT_GOALS,
    noteLabel: "CARE MANAGEMENT",
  },
  {
    noteType: MEMBER_DETAILS_CASE_STATUS_ACTIVE,
    noteLabel: "ACTIVE CASE STATUS",
  },
  {
    noteType: MEMBER_DETAILS_FOLLOWUP_REMINDER,
    noteLabel: "FOLLOW UP REMINDER CASE STATUS",
  },
  {
    noteType: MEMBER_DETAILS_CASE_STATUS_FOLLOW_UP,
    noteLabel: "FOLLOW UP CASE STATUS",
  },
  {
    noteType: MEMBER_DETAILS_CASE_STATUS_GRADUATED,
    noteLabel: "GRADUATED CASE STATUS",
  },
  {
    noteType: MEMBER_DETAILS_CASE_STATUS_DECLINED,
    noteLabel: "DECLINED CASE STATUS",
  },
  {
    noteType: MEMBER_DETAILS_CASE_STATUS_EXTERNAL,
    noteLabel: "EXTERNAL CASE STATUS",
  },
];

export const ASC = "ASC";
export const DESC = "DESC";
export const UPCOMING = "upcoming";
export const PAST = "past";
export const KNOWMORE = "knowmore";

/**
 * Care Management column mapping for calculating scores
 */

export const careManagementDependentFieldsForScore: any = {
  "KPS Score:": {
    "KPS: Conditions:": "param1",
    "KPS: Level of Functional Capacity:": "param2",
  },
  "Katz Score:": {
    "Katz: Bathing:": "param1",
    "Katz: Dressing:": "param2",
    "Katz: Feeding/ Eating:": "param3",
    "Katz: Transferring:": "param4",
    "Katz: Toileting:": "param5",
    "Katz: Continence:": "param6",
  },
  "Frail Scale Score:": {
    "Frail Scale: Fatigue:": "param1",
    "Frail Scale: Resistance:": "param2",
    "Frail Scale: Ambulation:": "param3",
    "Frail Scale: Illness:": "param4",
    "Frail Scale: Loss of Weight (Current Weight):": "param5",
    "Frail Scale: Loss of Weight (Weight 1 year ago):": "param6",
  },
  "Frail Phenotype Score:": {
    "Frailty Phenotype Indicator: Unintentional Weight Loss:": "param1",
    "Frailty Phenotype Indicator: Physical Activity:": "param2",
    "Frailty Phenotype Indicator: Exhaustion (Self- Reported):": "param3",
    "Frailty Phenotype Indicator: Strength / Weakness:": "param4",
    "Frailty Phenotype Indicator: Walking Time:": "param5",
  },
  "PPS Score:": {
    "PPS: Ambulation:": "param1",
    "PPS: Activity Level:": "param2",
    "PPS: Evidence of Disease:": "param3",
    "PPS: Self-Care:": "param4",
    "PPS: Intake:": "param5",
    "PPS: Level of Consciousness:": "param6",
  },
};

export const CASE_STATUS_ACTIVE = "Active";
export const CASE_STATUS_ON_HOLD = "On hold";
export const CASE_STATUS_FOLLOW_UP = "Follow Up";
export const CASE_STATUS_GRADUATED = "Graduated";
export const CASE_STATUS_DECLINED = "Declined";
export const CASE_STATUS_EXTERNAL = "External";
export const CASE_STATUS_CLOSED = "Closed";

export const CASE_STATUS_REASON_DEFAULT = "--";
export const CASE_STATUS_REASON_CASE_CLOSE = "Case Close";
export const CASE_STATUS_REASON_PROGRAM_CHANGE = "Program Change";
export const CASE_STATUS_REASON_FOLLOW_UP = "Follow Up";
export const CASE_STATUS_REASON_GRADUATED = "Graduated";
export const CASE_STATUS_REASON_DECLINED = "Declined";
export const CASE_STATUS_REASON_EXTERNAL = "External";

export const CASE_STATUS_REASON_NOTE = "Note";
export const CASE_STATUS_REASON_REMINDER = "Reminder";
export const CASE_STATUS_INFORMATION_UPDATE = "Information Updated";
export const CASE_STATUS_REASON_REPORT = "Report";
export const CASE_STATUS_REASON_CALCULATE_BUTTON = "Calculate Button";
export const CASE_STATUS_REASON_UPDATE = "Update";
export const CASE_STATUS_REASON_TASK_STATUS = "Task Status"
export const CASE_STATUS_REASON_GOAL = "Goal";
export const CASE_STATUS_REASON_ASSIGNMENT = "Assignment";

export const USER_ACTION_MODULE_MEMBER_DETAIL = "member-details";
export const USER_ACTION_MODULE_MEMBER_LIST = "member-list";

export const USER_ACTION_TAB_GLOBAL = "global";
export const USER_ACTION_TAB_MEMBER_PROFILE_HEADER = "member-profile-header";
export const USER_ACTION_TAB_CARE_MANAGEMENT = "care-management";
export const USER_ACTION_TAB_PROFILE_DETAILS = "profile-details";
export const USER_ACTION_TAB_DEFAULT = "--";
export const USER_ACTION_TAB_CONTACT_DETAILS = "contact-details";

export const USER_ACTION_CARD_MEMBER_PROFILE_RADIO = "member-profile-radio";
export const USER_ACTION_CARD_MEMBER_PROFILE_BUTTON = "member-profile-button";
export const USER_ACTION_CARD_RIGHT_NAVIGATION = "right-navigation";
export const USER_ACTION_CARD_MEMBER_LIST_TABLE = "member-list-table";
export const USER_ACTION_CARD_USER_REGISTRY = "user-registry";
export const USER_ACTION_CARD_CARE_PLAN_SUMMARY = "care-plan-summary";
export const USER_ACTION_CARD_KINS_INFORMATION = "kins-information";
export const USER_ACTION_CARD_PROGRAM = "program";
export const USER_ACTION_CARD_PHYSICIAN_CARE_PLAN = "physician-care-plan";
export const USER_ACTION_CARD_CARE_TEAM_ASSIGNMENT = "care-team-assignment";
export const USER_ACTION_CARD_CONTACT_INFORMATION = "contact-information";


export const USER_ACTION_LOCATION_ACTIVE = "active";
export const USER_ACTION_LOCATION_FOLLOW_UP = "follow up";
export const USER_ACTION_LOCATION_GRADUATED = "graduated";
export const USER_ACTION_LOCATION_DECLINED = "declined";
export const USER_ACTION_LOCATION_EXTERNAL = "external";

export const USER_ACTION_LOCATION_CASE_CLOSE = "case close";
export const USER_ACTION_LOCATION_PROGRAM = "program";
export const USER_ACTION_LOCATION_DEFAULT = "--";
export const USER_ACTION_LOCATION_GOAL = "goal";
export const USER_ACTION_LOCATION_GOAL_NOTE = "goal-note";
export const USER_ACTION_LOCATION_TASK_NOTE = "task-note";
export const USER_ACTION_LOCATION_TASK_REMINDER = "task-reminder";
export const USER_ACTION_LOCATION_TASK_DROPDOWN = "task-dropdown";
export const USER_ACTION_LOCATION_TASK_BUTTON = "task-button";
export const USER_ACTION_LOCATION_TASK_UPDATE_BUTTON = "task-update-button";
export const USER_ACTION_LOCATION_GENERATE_REPORT = "generate-report";
export const USER_ACTION_LOCATION_SAVE_CHANGES = "save-changes";
export const USER_ACTION_LOCATION_INTERVENTION_HEADER = "intervention-header";
export const USER_ACTION_LOCATION_CARE_PLAN_BUTTON = "care-plan-button";
export const USER_ACTION_LOCATION_WORK_STATUS_DONE = "work-status$|done";

export const USER_ACTION_DESCRIPTION_STATUS_CHANGE = "status-change";
export const USER_ACTION_DESCRIPTION_NOTE_SAVE = "note-save";
export const USER_ACTION_DESCRIPTION_NOTE_DELETE = "note-delete";
export const USER_ACTION_DESCRIPTION_NOTE_BOOKMARK = "note-bookmark";
export const USER_ACTION_DESCRIPTION_NOTE_UPDATE = "note-update";
export const USER_ACTION_DESCRIPTION_REGISTRY_UPDATE = "registry-update";

export const USER_ACTION_DESCRIPTION_REMINDER_SAVE = "reminder-save";
export const USER_ACTION_DESCRIPTION_REMINDER_DELETE = "reminder-delete";
export const USER_ACTION_DESCRIPTION_REMINDER_UPDATE = "reminder-update";

export const USER_ACTION_DESCRIPTION_PROGRAM_SAVE = "program-save";
export const USER_ACTION_DESCRIPTION_PROGRAM_COMPLETE = "program-complete";

export const USER_ACTION_DESCRIPTION_GOAL_SAVE = "goal-save";
export const USER_ACTION_DESCRIPTION_GOAL_DELETE = "goal-delete";
export const USER_ACTION_DESCRIPTION_GOAL_UPDATE = "goal-update";
export const USER_ACTION_DESCRIPTION_GOAL_MARK = "goal-mark";
export const USER_ACTION_DESCRIPTION_GOAL_COMPLETE = "goal-complete";
export const USER_ACTION_DESCRIPTION_TASK_STATUS_CHANGE = "task-status-change";
export const USER_ACTION_DESCRIPTION_TASK_UPDATE = "task-update";
export const USER_ACTION_DESCRIPTION_PROGRAM_ASSIGNMENT = "program-assignment";
export const USER_ACTION_DESCRIPTION_REPORT_DOWNLOAD = "report-download";
export const USER_ACTION_DESCRIPTION_REPORT_UPLOAD = "report-upload";
export const USER_ACTION_DESCRIPTION_SCORE_CALCULATE = "score-calculate";
export const USER_ACTION_DESCRIPTION_KINS_INFORMATION_SAVE = "kins-information-save";
export const USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_SAVE = "care-plan-note-save";
export const USER_ACTION_DESCRIPTION_CARE_PLAN_NOTE_UPDATE = "care-plan-note-update";
export const USER_ACTION_DESCRIPTION_CONTACT_DETAIL_SAVE = "contact-detail-save";

export const REGISTRY_LINKED_CARE_PROGRAM_MAPPING: any = {
  HRP: {
    classificationType: "HIGHRISK",
    dataIndex: "patient_hrp_status",
    programName: "High Risk",
  },
  // "EOL": {
  //   classificationType: "EOL",
  //   dataIndex: 'patient_eol_status',
  //   programName: 'End Of Life',
  // },
  // "HIP": {
  //   classificationType: "HIGHINTENSITY",
  //   dataIndex: 'patient_hip_status',
  //   programName: 'High Intensity',
  // },
};

export const accessConfig = {
  'ReminderNotification' : ['Mycare' , 'Tredence' , 'Tredence Dev' , 'Millennium', 'Centric']
}

export const ACTIVE = "To Do";
export const COMPLETE = "Done";
export const INPROGRESS = "In Progress";
export const NOT_APPLICABLE = "Not Applicable";
export const NOTE = "NOTE";
export const NOT_ASSIGNED = "Not Assigned";
export const CONFIRMATION = "CONFIRMATION";
export const TRIGGERED = "Triggered";

export const dashBoardReportPageMapping = {
  mpgTCMReport: "TCM-DASHBOARD",

  mpgERReport: "ER-DASHBOARD",

  mpgHRPReport: "HRP-DASHBOARD",

  mpgSDOHReport: "SDOH-Dashboard",

  mpgEOLReport: "EOL-Dashboard",

  mpgDiaReport: "DIABETES-DASHBOARD",

  mpgCOPDReport: "COPD-DASHBOARD",

  mpgHTNReport: "HTN-DASHBOARD",

  mpgHFReport: "HF-DASHBOARD",

  mpgDepReport: "DEP-DASHBOARD",

  mpgDietReport: "DIETICIAN-DASHBOARD",

  mpgDiaEduReport: "DIAEDUCATOR-DASHBOARD",

  mpgPPCReport: "PPC-DASHBOARD",

  mpgPltveReport: "PALLIATIVE-DASHBOARD",

  mpgSWokerReport: "SOCAIL-DASHBOARD",

  mpgOverallReport : 'OVERALL-DASHBOARD',

  mpgCasemgrReport : 'CASEMGR-DASHBOARD',

  mpgCOReport: 'CO-DASHBOARD',

  mpgCadenceReport: 'CADENCE-DASHBOARD',

  mpgGenPrgmReport : 'GEN-DASHBOARD',

  mpgFreqUtilPrgmReport : 'FREQ-DASHBOARD',

  aetnaMedicalSupplementalData: "AETNA-MEDICAL-SUPPLEMENTAL-DASHBOARD",

  aetnaLabSupplementalData: "AETNA-LAB-SUPPLEMENTAL-DASHBOARD",

  BNDSupplementalData: "BND-SUPPLEMENTAL-DASHBOARD",

  HealthNetMedicalSupplementalData: "HEALTHNET-MEDICAL-SUPPLEMENTAL-DASHBOARD",

  HealthNetLabSupplementalData: "HEALTHNET-LAB-SUPPLEMENTAL-DASHBOARD",

  GapReports: "HCC-GAP-REPORT",

  CentralHealthPlanMedicalSupplementalData: "CENTRAL-HEALTH-PLAN-MEDICAL-SUPPLEMENTAL-DASHBOARD",

  CentralHealthPlanLabSupplementalData: "CENTRAL-HEALTH-PLAN-LAB-SUPPLEMENTAL-DASHBOARD",

  CareTeamReport: "CARE-TEAM-REPORT",

  ProviderReport: "PROVIDER-REPORT",

  HistorialGapReports: "HCC-PERIODICAL-GAP-REPORT"

};

const createDefaultSortData = (pageName : string) => ({
  [pageName]: {
    order: "ascend",
    columnKey: "patient_name",
  },
});


const dashBoardTableReportDefaultSortData = Object.values(dashBoardReportPageMapping)
  .map(createDefaultSortData)
  .reduce((result, currentObject) => ({
    ...result,
    ...currentObject,
  }), {});

  export const defaultSortData : SortData = {
    // 'Member List' : {"order": "ascend", "columnKey": "priority"},
    // 'Member List Emergency':{"order": "ascend", "columnKey": "discharge_date"},
    // 'Member List Inpatient':{"order": "descend", "columnKey": "admission_date"},
    // 'Member List Admitted':{"order": "descend", "columnKey": "admission_date"},
    'InPatient Management Report' : {},
    'ADT Feed' : {},
    'Encounters Data' : {},
    'High Cost Report' : {"order": "ascend", "columnKey": "current_rank"},
    'Medications' : {},
    'Medical Diagnosis' : {},
    'Medical Type Of Bill' : {},
    'Medical Drg' : {},
    'Medical Place Of Service' : {},
    'Medical Procedure' : {},
    'Medical Revenue' : {},
    ...(dashBoardTableReportDefaultSortData || {})
  }

  export const defaultFilterMapping: any = {
    mpgCasemgrReport: {
      patient_case_status: {
        type: "ACTN-MSELDRPDWN",
        displayName: "Case Status",
        value: ["Active"],
      },
    },
  };

export const negativeOutcomeOfOutreach = ["referred to ed", "no answer/left voicemail", "no answer/unable to leave voicemail" , 'declined service/call' , 'phone not in service'];

export const positiveOutComeOfOutreach = ['pcp appointment scheduled',  "referred to urgent care", "continue and follow-up as per cadence", "spoke with patient", "spoke with family/caregiver" , 'portal message sent' , 'face to face visit' , 'face to face visit with family/caretaker' , 'provider intervention'];

export const CPSR_REPORT_UPLOAD_PROGRESS_DATA = [
  { progress: 30, message: "Connecting to Athena Health API." },
  { progress: 60, message: "Uploading to Athena Health Patient Chart" },
  { progress: 90, message: "Please wait, you are almost there!" },
]
export const GLOBAL_SEARCH_DROPDOWN_KEY = 'global_search';

export const CPSR_REPORT_CONTENT_INITIAL_STATE = { patientLevelNotes: true, physicianCarePlan: false , careTeamDetails : false , riskScore : true , patientDetails : true};

export const OUTREACH_FILTER = 'outreach_filter';

export const OUTREACH_ADD = 'outreach_add';

export const ALL_OUTREACHES = 'All Outreaches';

export const MY_OUTREACHES = 'My Outreaches';

export const PHYSICIAN_CARE_PLAN_NOTE = 'physician_care_plan_note';

export const EDIT = 'EDIT';

export const DELETE = 'DELETE';

export const SUBTRACT = 'SUBTRACT';

export const ADD = 'ADD';

export const claimTypeLegendColors: any = {
  Medical: "#807AF4",
  Pharmacy: "#F1946F",
};

export const CARE_GAP_STATUS_OPTIONS = ["Open", "Working", "Completed", "CLOHP", "N/A", "Other"];


//Commented for applying the new rules to block/unblock options as per new requirement

// export const HEALTH_PLAN_CATEGORY_TRANSITION_RULES: Record<string, string[]> = {
//   Open: ["Open", "Working", "N/A", "Other"],
//   Working: ["Working", "Completed", "CLOHP"],
//   Completed: ["Completed", "CLOHP"],
//   CLOHP: ["CLOHP", "Completed"],
//   "N/A": ["N/A", "Open", "Working", "Completed", "CLOHP", "Other"],
//   Other: ["Other", "Open", "Working", "Completed", "CLOHP", "N/A"],
// };

//New requirement applied below:-->

export const HEALTH_PLAN_CATEGORY_TRANSITION_RULES: Record<string, string[]> = {
  Open: ["Open", "Working", "Completed", "N/A", "Other"],
  Working: ["Working", "Completed", "Other"],
  Completed: ["Completed"],
  CLOHP: ["Working", "Completed", "Other"],
  "N/A": ["N/A", "Open", "Other",],
  Other: ["Other", "Working", "Completed"],
};